import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rectangle creams/rectangle strawberry biscuit.png";
import BiscuitImg from "../../../assets/products/rectangle creams/Rectangle-Strawberry.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 75,
  },
  {
    grams: 80,
  },
];

export default function StrawberryRectangleProduct() {
  return (
    <>
      <Helmet>
        <title>
          Rectangle Strawberry Cream Biscuit – BearBitz | Premium Biscuits &
          Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Rectangle Strawberry Cream Biscuits — sweet strawberry-flavored sandwich biscuits with creamy filling. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Rectangle Strawberry Cream Biscuit, BearBitz Strawberry Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/rectangle-cream-biscuit/rectangle-strawberry"
        />
        <meta
          property="og:title"
          content="Rectangle Strawberry Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled strawberry sandwich biscuit in rectangle shape with export-ready packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="STRAWBERRY"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF009F"
        sectionBgColor="#FFDBF4"
        productBgcolor="#FFADE6"
        tableheadBgcolor="#FF009F"
        tableBgcolor="#FFF1FB"
        footerBgcolor="#FF009F"
      />
    </>
  );
}
